<template>
  <div class="client">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <b-tabs card>
              <b-tab title="Cadastro" active>
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-12">
                      <div class="title-section">Dados do cliente</div>
                    </div>
                  </div>
                  <div class="row type-user">
                    <div class="col-lg-3 offset-lg-9 col-12">
                      <select
                        class="form-control"
                        v-model="client.type"
                        :disabled="formType == 'edit'"
                      >
                        <option
                          v-for="(item, index) in createParams.types"
                          v-bind:key="index"
                          :value="item"
                        >{{item}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label>
                          Nome
                          <span class="required-field">*</span>
                        </label>
                        <input type="text" v-model="client.name" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="client.type == 'Pessoa física' || client.type == 'Promocional'"
                  >
                    <div class="col-lg-6 col-12">
                      <div class="form-group">
                        <label>RG</label>
                        <input type="text" v-model="client.rg" class="form-control" />
                      </div>
                    </div>
                    <div class="col-lg-6 col-12">
                      <div class="form-group">
                        <label>CPF</label>
                        <input
                          type="text"
                          v-model="client.cpf"
                          v-mask="'###.###.###-##'"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="client.type == 'Pessoa jurídica'">
                    <div class="col-lg-6 col-12">
                      <div class="form-group">
                        <label>Inscrição Estadual</label>
                        <input v-model="client.state_registration" class="form-control" />
                      </div>
                    </div>
                    <div class="col-lg-6 col-12">
                      <div class="form-group">
                        <label>CNPJ</label>
                        <input
                          type="text"
                          v-model="client.cnpj"
                          v-mask="'##.###.###/####-##'"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="client.type == 'Pessoa física' || client.type == 'Promocional'"
                  >
                    <div class="col-lg-12 col-12">
                      <div class="form-group">
                        <label>Data de nascimento</label>
                        <b-form-datepicker
                          id="birth-datepicker"
                          v-model="client.birth_date"
                          placeholder="Escolha uma data"
                          class="mb-2"
                        ></b-form-datepicker>
                      </div>
                    </div>
                    <!-- <div class="col-lg-6 col-12">
                      <div class="form-group">
                        <label>
                          Gênero
                        </label>
                        <select v-model="client.gender" class="form-control">
                          <option value disabled selected>Selecione um gênero</option>
                          <option
                            v-for="(item, index) in createParams.gender"
                            :value="item"
                            v-bind:key="index"
                          >{{item}}</option>
                        </select>
                      </div>
                    </div>-->
                  </div>
                  <div class="row" v-if="client.type == 'Pessoa jurídica'" v-bind:key="client.type">
                    <div class="col-lg-6 col-12">
                      <div class="form-group">
                        <label>Razão Social</label>
                        <input type="text" v-model="client.social_name" class="form-control" />
                      </div>
                    </div>
                    <div class="col-lg-6 col-12">
                      <div class="form-group">
                        <label>Contato</label>
                        <input type="text" v-model="client.name_contact" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <address-form-component :address="client.address"></address-form-component>
                    </div>
                    <div class="col-12">
                      <contact-form-component :contact="client.contact"></contact-form-component>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label for>Observações</label>
                        <textarea v-model="client.comments" class="form-control"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="client.type != 'Promocional'">
                    <div class="col-12">
                      <div class="title-section">Produtos</div>
                    </div>
                    <div class="col-lg-6 col-12">
                      <div class="form-group">
                        <label>Funcionalidades</label>
                        <multiselect
                          v-model="products"
                          :multiple="true"
                          :options="createParams.products"
                          selectLabel="Selecione esse produto"
                          deselectLabel="Remova esse produto"
                          selectedLabel="Selecionado"
                          track-by="id"
                          label="name"
                          placeholder="Selecione os produtos"
                        ></multiselect>
                      </div>
                    </div>
                    <div class="col-lg-6 col-12">
                      <div class="form-group">
                        <label>Revistas</label>
                        <multiselect
                          v-model="magazines"
                          :multiple="true"
                          :options="createParams.magazines"
                          selectLabel="Selecione essa revista"
                          deselectLabel="Remova essa revista"
                          selectedLabel="Selecionada"
                          track-by="id"
                          label="name"
                          placeholder="Selecione as revistas"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="row consulting-data" v-if="hasConsulting">
                    <div class="col-12 title">
                      <span>Dados da consultoria (quantidade 0 significa sem limites):</span>
                    </div>
                    <div class="col-lg-5 col-12">
                      <div class="form-group">
                        <label for>Data inicial</label>
                        <b-form-datepicker
                          id="example-datepicker"
                          v-model="client.consulting_start_date"
                          placeholder="Escolha uma data"
                          class="mb-2"
                        ></b-form-datepicker>
                      </div>
                    </div>
                    <div class="col-lg-5 col-12">
                      <div class="form-group">
                        <label for>Data final</label>
                        <b-form-datepicker
                          id="end-datepicker"
                          v-model="client.consulting_end_date"
                          placeholder="Escolha uma data"
                          class="mb-2"
                        ></b-form-datepicker>
                      </div>
                    </div>
                    <div class="col-lg-2 col-12">
                      <div class="form-group">
                        <label for>Quantidade</label>
                        <input
                          type="number"
                          v-model="client.consulting_qtd"
                          min="0"
                          name
                          id
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="title-section">Dados comerciais</div>
                    </div>
                    <div class="col-lg-5 col-12">
                      <div class="form-group">
                        <label for>Vendedor</label>
                        <select v-model="client.seller_id" class="form-control">
                          <option
                            v-for="(item, index) in createParams.sellers"
                            :value="item.id"
                            v-bind:key="index"
                          >{{item.name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-4 col-12" v-if="client.type != 'Promocional'">
                      <div class="form-group">
                        <label for>Data de renovação</label>
                        <b-form-datepicker
                          id="renovation-datepicker"
                          v-model="client.renovation_date"
                          placeholder="Escolha uma data"
                          class="mb-2"
                        ></b-form-datepicker>
                      </div>
                    </div>

                    <div class="col-lg-3 col-12">
                      <div class="form-group">
                        <label for>
                          Situação do Cliente
                          <span class="required-field">*</span>
                        </label>
                        <select v-model="client.status" class="form-control">
                          <option
                            v-for="(item, index) in createParams.status"
                            :value="item"
                            v-bind:key="index"
                          >{{item}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="client.type == 'Promocional'">
                    <div class="col-lg-4 col-12">
                      <div class="form-group">
                        <label for>Data de inicio</label>
                        <b-form-datepicker
                          id="promo-start-datepicker"
                          v-model="client.promotional_start_date"
                          placeholder="Escolha uma data"
                          class="mb-2"
                        ></b-form-datepicker>
                      </div>
                    </div>
                    <div class="col-lg-4 col-12">
                      <div class="form-group">
                        <label for>Data de fim</label>
                        <b-form-datepicker
                          id="promo-end-datepicker"
                          v-model="client.promotional_end_date"
                          placeholder="Escolha uma data"
                          class="mb-2"
                        ></b-form-datepicker>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="(client.type == 'Pessoa física' || client.type == 'Promocional')  && formType == 'create'"
                  >
                    <div class="col-12">
                      <div class="title-section">Dados de login</div>
                    </div>
                    <div class="col-lg-4 col-12">
                      <div class="form-group">
                        <label for>
                          Login
                          <span class="required-field">*</span>
                        </label>
                        <input
                          type="text"
                          v-model="user.login"
                          class="form-control"
                          v-on:change="verifyUniqueLogin()"
                        />
                      </div>
                    </div>
                    <div class="col-lg-4 col-12">
                      <div class="form-group">
                        <label for>
                          Senha
                          <span class="required-field">*</span>
                        </label>
                        <input type="password" v-model="user.password" class="form-control" />
                      </div>
                    </div>
                    <div class="col-lg-4 col-12">
                      <div class="form-group">
                        <label for>
                          Confirmar senha
                          <span class="required-field">*</span>
                        </label>
                        <input type="password" v-model="user.confirm_password" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <button class="btn btn-primary float-right" v-on:click="save()">Salvar</button>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Usuários" :disabled="formType == 'create'">
                <users-list-component :client_id="id" :client_type="client.type"></users-list-component>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import Multiselect from "vue-multiselect";
import AddressFormComponent from "@/components/forms/AddressFormComponent";
import ContactFormComponent from "@/components/forms/ContactFormComponent";
import UsersListComponent from "@/components/clients/UsersListComponent";
import moment from "moment";
import validator from "@/imports/validator/validate";
import helper from "@/imports/Helpers";
import Swal from "sweetalert2";
import client_pj_validate from "@/imports/validator/models/cliente_juridica";
import client_pf_validate from "@/imports/validator/models/cliente_fisica";
import client_prom_validate from "@/imports/validator/models/cliente_promocional";
import address_validate from "@/imports/validator/models/address";
import contact_validate from "@/imports/validator/models/contact";
import user_validate from "@/imports/validator/models/cliente_user";
import consulting_validate from "@/imports/validator/models/consulting_params";
import contact from "@/imports/validator/models/contact";
import { bus } from "@/main";

export default {
  name: "client",
  components: {
    AddressFormComponent,
    ContactFormComponent,
    Multiselect,
    UsersListComponent,
  },
  props: {
    id: Number,
  },
  data() {
    return {
      formType: "create",
      hasConsulting: false,
      products: [],
      magazines: [],
      user: {
        can_change_password: true,
      },
      client: {
        type: "Pessoa física",
        address: {},
        contact: {},
      },
      createParams: {
        products: [],
        magazines: [],
      },
      items: [
        {
          text: "Clientes",
          route: "admin.clients",
        },
        {
          text: "Novo Cliente",
          active: true,
        },
      ],
    };
  },
  watch: {
    products() {
      this.hasConsulting = false;
      this.products.forEach((el) => {
        if (el.name == "Consultoria") {
          this.hasConsulting = true;
        }
      });
    },
  },
  mounted() {
    this.getCreateParams();
    if (this.id) {
      this.formType = "edit";
      this.getDataObject(this.id);
    }
  },
  methods: {
    getDataObject: function (id) {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/clients/${id}`)
        .then((response) => {
          this.client = response.data;
          this.magazines = this.client.magazines;
          this.products = this.client.products;
          this.items[1].text = this.client.name;

          if (this.client.products) {
            this.client.products.forEach((element) => {
              if (element.name == "Consultoria")
                this.client.consulting_qtd = element.pivot.quantity;
            });
          }
          bus.$emit("changeLoading", false);
        });
    },
    getCreateParams: function () {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/clients/create`)
        .then((data) => {
          this.createParams = data.data;
          bus.$emit("changeLoading", false);
        });
    },
    verifyUniqueLogin() {
      axios
        .post(`${process.env.VUE_APP_API_HOST}/api/unique_login`, {
          login: this.user.login,
        })
        .then((response) => {
          if (response.data.exists == 1) {
            Swal.fire({
              title: "Parece que esse login já existe",
              icon: "info",
            });
            this.user.login = "";
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "Ocorreu um erro.",
            icon: "error",
          });
        });
    },
    save: function () {
      let errors = validator.validate(
        this.client,
        this.client.type == "Pessoa física"
          ? client_pf_validate.model
          : this.client.type == "Pessoa jurídica"
          ? client_pj_validate.model
          : client_prom_validate.model
      );
      // errors = errors.concat(
      //   validator.validate(this.client.address, address_validate.model)
      // );
      // errors = errors.concat(
      //   validator.validate(this.client.contact, contact_validate.model)
      // );
      if (
        (this.client.type == "Pessoa física" ||
          this.client.type == "Promocional") &&
        this.formType == "create"
      ) {
        errors = errors.concat(
          validator.validate(this.user, user_validate.model)
        );
      }
      if (this.hasConsulting) {
        errors = errors.concat(
          validator.validate(this.client, consulting_validate.model)
        );
      }
      if (errors.length == 0) {
        bus.$emit("changeLoading", true);
        let products_ids = [];
        let magazines_ids = [];

        if (this.client.type != "Promocional") {
          this.products.forEach((el) => products_ids.push(el.id));
          this.magazines.forEach((el) => magazines_ids.push(el.id));
        } else {
          this.createParams.products.forEach((el) => {
            if (el.name != "Consultoria") products_ids.push(el.id);
          });
          this.createParams.magazines.forEach((el) =>
            magazines_ids.push(el.id)
          );
        }

        this.client.magazines = magazines_ids;
        this.client.products = products_ids;

        if (this.client.contact.mail_marketing == "true") {
          this.client.contact.mail_marketing = true;
        }
        if (this.client.contact.mail_marketing == "false") {
          this.client.contact.mail_marketing = false;
        }

        this.user.name = this.client.name;
        this.user.status = this.client.status;
        this.user.user_type_id = 2;

        if (
          this.client.type == "Pessoa física" ||
          this.client.type == "Promocional"
        ) {
          if (this.client.rg != undefined && this.client.rg != null) {
            this.client.rg = helper.formatOnlyCharsString(this.client.rg);
          }
          if (this.client.cpf != undefined && this.client.cpf != null) {
            this.client.cpf = helper.formatOnlyCharsString(this.client.cpf);
          }
          if (this.formType == "create") {
            this.client.user = this.user;
          }
        }
        if (this.client.cnpj != null && this.client.cnpj != undefined) {
          this.client.cnpj = helper.formatOnlyCharsString(this.client.cnpj);
        }

        let promise =
          this.formType == "create"
            ? axios.post(
                `${process.env.VUE_APP_API_HOST}/api/clients`,
                this.client
              )
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/clients/${this.client.id}`,
                this.client
              );

        promise
          .then((response) => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title:
                this.formType == "create"
                  ? "Novo cliente cadastrado"
                  : "Cliente alterado com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.clients" });
              },
            });
          })
          .catch((error) => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error",
            });
          });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach((el) => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning",
        });
      }
    },
    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.client {
  .title-section {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 8px;
  }
  .type-user {
    margin-bottom: 12px;
  }
  .consulting-data {
    margin-bottom: 12px;
    .title {
      margin-top: 12px;
      margin-bottom: 8px;
    }
  }
  .card-header {
    background-color: white;
    a {
      text-decoration: none;
      color: $red_primary;
    }
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>